import { useAuthContext } from "providers/Auth";
import { FC } from "react";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { Plus } from "untitledui-js-base";

type Props = {
  handleCopyLink: () => void;
  setShowAddUnitModal: (show: boolean) => void;
};

export const LayoutButtons: FC<Props> = ({
  handleCopyLink,
  setShowAddUnitModal
}) => {
  const { type } = useAuthContext();

  if (!type.isSDK && type.isBoomScreen)
    return (
      <>
        <Button
          variant={ButtonVariant.BASE}
          className="w-full md:w-auto"
          size={ButtonSize.SM}
          onClick={handleCopyLink}
        >
          Copy Portfolio Link
        </Button>
        {type.isAdmin || type.isOwner ? (
          <Button
            className="w-full md:w-auto"
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.SM}
            onClick={() => setShowAddUnitModal(true)}
            Icon={Plus}
          >
            Add Unit
          </Button>
        ) : null}
      </>
    );

  if (type.isManual && (type.isAdmin || type.isOwner))
    return (
      <Button
        className="w-full md:w-auto"
        variant={ButtonVariant.PRIMARY}
        size={ButtonSize.SM}
        onClick={() => setShowAddUnitModal(true)}
        Icon={Plus}
      >
        Add Unit
      </Button>
    );

  return null;
};
